module.exports = __webpack_public_path__ + "static/media/10_uh_a.da7b571e.ogg";